import { ICellRendererParams } from '@ag-grid-community/core';
import * as React from 'react';
import { style } from 'typestyle';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';
import { isNil } from 'lodash';

export const IconCellRendererStyles = {
  container: style({
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  }),
  text: style({
    color: 'black', // prevents inheriting classByCalc color
  }),
};

export interface Params extends ICellRendererParams {
  icon: string;
  value: any;
  dataQa?: string;
  onCellClicked?: (params: BasicPivotItem) => Record<string, any>;
}

export class IconWithTextCellRenderer extends React.Component<Params> {
  constructor(props: Params) {
    super(props);
  }

  handleClick = () => {
    const { data, onCellClicked } = this.props;

    if (onCellClicked) {
      onCellClicked(data);
    }
  };

  render() {
    const { value, icon, dataQa } = this.props;

    let iconClass = `fa fa-${icon}`;
    if (iconClass.startsWith('far') || iconClass.startsWith('fas') || iconClass.startsWith('fa')) {
      iconClass = icon;
    }

    return (
      <div
        data-qa={dataQa}
        className={IconCellRendererStyles.container}
        onClick={this.handleClick}
      >
        {/* text left */}
        {!isNil(value) ? (
          <span className={IconCellRendererStyles.text}>
            {value}
          </span>
        ) : null}

        {/* icon right, color from classByCalc */}
        <i className={iconClass} />
      </div>
    );
  }
}
